import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconFiletypeDoc = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      width={99.999}
      height={98.661}
      viewBox="0 0 26.458 26.104"
      xmlns="http://www.w3.org/2000/svg"
      className="block w-full h-full fill-current"
    >
      <path
        d="M6.74 24.318v-1.654H.127V8.726h6.615V.103h13.88l5.727 5.73v20.138H6.741z"
        fill="#fff"
      />
      <path
        d="M6.616 24.442c0-1.391.005-1.699.005-1.699l.358.015-.009 2.983h19.135V6.133h-1.063c-.854 0-2.686-.006-2.686-.006l-.687-.38 4.32-.027L20.673.407v1.091c0 .892-.005 1.616-.005 1.616s-.35-.386-.35.007c0 .394.343.11.343.11s.012.58.012 1.13l.001 1.201s-.356-.354-.356.04v.531H9.097V5.07h11.22V3.653H9.097V2.59h11.22V.346H6.97l.018 8.463-.376-.024s.003-.729.003-4.482V-.01h14.117l5.727 5.73v20.374H6.615zm2.48-1.3v-.354h2.54c2.178 0 1.04-.092 1.04-.244 0-.154 2.123-.11 6.401-.11h4.902v1.063H9.096zm5.08-2.657v-.532h9.803v1.063h-9.804zm0-2.48v-.532h9.803v1.063h-9.804zm0-2.481v-.532h9.803v1.063h-9.804zm0-2.48v-.532h9.803v1.063h-9.804zm0-2.481v-.531h9.803v1.063h-9.804zm-5.08-2.48V7.55H23.98v1.063H9.096z"
        fill="#999898"
      />
      <path
        d="M20.317 5.602v-.531l.354-.004v.668h3.283l.011.394s-.269.005-1.818.005h-1.83zm0-1.948V2.59l.348.008.001 1.056z"
        fill="#676566"
      />
      <path
        d="M.004 15.705V8.618h14.174v14.174H.004zm13.111 1.713v-4.311h-.273c-.24 0-.51.449-2.119 3.514l-1.845 3.514-2.135.067-.065-3.414-1.964 3.406H2.84v-7.087h-.945v-1.418h4.252v1.418H5.083l.02 2.54 1.91-3.958h1.968l.003 4.075.76-1.299.762-1.3-.817-.073V11.69h3.426V9.681H1.067V21.73h12.048z"
        fill="#295595"
      />
    </svg>,
  );
IconFiletypeDoc.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconFiletypeDoc;
